import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Logs() {
  const [kind, setKind] = useState("admin");
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get(`/admin/logs?kind=${kind}`).then((r) => setRows(r.data)).catch(() => {}); }, [kind]);
  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-extrabold text-white">Loglar</h1>
        <select value={kind} onChange={(e) => setKind(e.target.value)} className="bg-[#171922] border border-white/10 rounded-xl px-4 py-2.5 text-white text-sm">
          <option value="admin">Admin Logları</option><option value="api">API Logları</option>
        </select>
      </div>
      <div className="card-surface overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-gray-400 text-left border-b border-white/10">{(kind === "admin" ? ["Tarih", "Admin", "İşlem", "Detay"] : ["Tarih", "Tip", "Sipariş", "Yanıt"]).map((h) => <th key={h} className="px-4 py-3 font-medium">{h}</th>)}</tr></thead>
          <tbody>
            {rows.map((l, i) => (
              <tr key={i} className="border-b border-white/5">
                <td className="px-4 py-3 text-gray-400 text-xs whitespace-nowrap">{(l.created_at || "").replace("T", " ").slice(0, 19)}</td>
                {kind === "admin" ? <>
                  <td className="px-4 py-3 text-gray-300">{l.admin}</td>
                  <td className="px-4 py-3 text-white">{l.action}</td>
                  <td className="px-4 py-3 text-gray-400">{l.detail}</td>
                </> : <>
                  <td className="px-4 py-3 text-white">{l.type}</td>
                  <td className="px-4 py-3 text-gray-400">{l.order_number || "-"}</td>
                  <td className="px-4 py-3 text-gray-400 max-w-[400px] truncate" title={l.response}>{l.response}</td>
                </>}
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={4} className="px-4 py-10 text-center text-gray-500">Log yok</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
